<template>
  <div>
    <a-card class="policies-list-card">
      <a-row>
        <a-col>
          <div class="flex items-center justify-between mb-8">
            <h2 class="text-2xl ">Rivenditori</h2>

            <div class="flex items-center">
              <a-button @click="refresh" class="flex items-center mr-2">
                Aggiorna
                <a-icon type="sync" :spin="refreshing" :style="{ color: '#ed8936' }" />
              </a-button>

              <a-button @click="newModalOpened = true" class="flex items-center">
                Aggiungi nuovo
              </a-button>
            </div>
          </div>

          <div>
            <a-table
              :loading="gettingResellers"
              :pagination="paginationInfo"
              :columns="columns"
              :dataSource="resellers"
              :rowKey="record => record.id"
            >
              <span slot="orders_count" slot-scope="orders_count, record">
                {{ record.orders_count }} ({{ record.active_orders }})
              </span>

              <div slot="delete" slot-scope="text, record" class="flex items-center">
                <a-tooltip placement="left">
                  <template slot="title">
                    <span>{{ VUE_APP_REFERRAL_LINK_TEMPLATE + record.ref }}</span>
                  </template>

                  <div
                    class="pressable cursor-pointer mr-4 px-2 text-sm border border-gray-400 rounded flex justify-center items-center"
                    @click="() => copyLink(VUE_APP_REFERRAL_LINK_TEMPLATE + record.ref)"
                  >
                    Copia Link Referral
                  </div>
                </a-tooltip>

                <a-tooltip placement="left">
                  <template slot="title">
                    <span>Mostra QRcode</span>
                  </template>

                  <span>
                    <svgicon
                      name="qrcode"
                      width="28"
                      height="28"
                      class="mr-6 cursor-pointer"
                      color="#ed8936"
                      @click="() => showQRCodeModal(record)"
                    ></svgicon>
                  </span>
                </a-tooltip>

                <a-popconfirm
                  title="Vuoi eliminare questo rivenditore? L'operazione non è reversibile."
                  @confirm="deleteReseller(record.id)"
                  okText="Sì"
                  cancelText="No"
                  placement="left"
                >
                  <a-icon
                    :style="{ fontSize: '24px', color: 'red' }"
                    :type="deleting[record.id] ? 'loading' : 'delete'"
                  />
                </a-popconfirm>
              </div>
            </a-table>
          </div>
        </a-col>
      </a-row>
    </a-card>

    <a-modal
      okText="Aggiungi"
      @ok="create"
      :ok-button-props="{ props: { loading: creating } }"
      v-model="newModalOpened"
      title="Nuovo Rivenditore"
    >
      <a-form layout="vertical" :form="newResellerForm">
        <a-form-item>
          <label class="font-bold" slot="label">Nome rivenditore</label>
          <a-input
            html-type="text"
            v-decorator="[
              'name',
              {
                rules: [{ required: true, message: 'Inserisci il nome del rivenditore' }]
              }
            ]"
          />
        </a-form-item>
      </a-form>
    </a-modal>

    <a-drawer
      placement="right"
      :closable="true"
      @close="QRCodeModalOpened = false"
      :visible="QRCodeModalOpened"
      class="flex-col h-full"
      :afterVisibleChange="generateQRCode"
      :width="480"
      title="QRCode"
    >
      <div class="pb-10" v-if="selectedReseller">
        Quando inquadrato, questo QRCode porta alla piattaforma I4M utilizzando il codice del
        rivenditore:
        <pre>{{ selectedReseller.name }}</pre>
      </div>

      <div class="flex flex-col items-center">
        <div class="flex justify-center" id="qr-code-canvas"></div>

        <a-button @click="download" size="small" class="mt-8">
          Scarica QRCode
        </a-button>
      </div>
    </a-drawer>
  </div>
</template>

<script>
// import BrokerOrdersList from '@/components/BrokerOrdersList.vue';
import api from '@/api.js';
import Vue from 'vue';
import QRCodeStyling from 'qr-code-styling';

export default {
  name: 'Resellers',
  components: {},

  beforeCreate() {
    this.newResellerForm = this.$form.createForm(this, { name: 'reseller_form' });
  },

  data: function() {
    return {
      activeKey: 0,
      columns: [
        {
          dataIndex: 'name',
          key: 'name',
          title: 'Nome'
        },
        {
          title: 'Codice',
          key: 'ref',
          dataIndex: 'ref'
        },
        {
          title: 'Ordini (completati)',
          key: 'orders_count',
          dataIndex: 'orders_count',
          scopedSlots: { customRender: 'orders_count' }
        },
        {
          title: '',
          key: 'delete',
          scopedSlots: { customRender: 'delete' }
        }
      ],

      QRCodeModalOpened: false,

      gettingResellers: true,
      paginationInfo: {},
      resellers: [],
      creating: false,

      newModalOpened: false,
      deleting: {},

      selectedReseller: null,
      qrCodeGenerated: null,

      refreshing: false,

      VUE_APP_REFERRAL_LINK_TEMPLATE: process.env.VUE_APP_REFERRAL_LINK_TEMPLATE
    };
  },

  mounted: async function() {
    this.getResellers();
  },

  methods: {
    copyLink(link) {
      this.$copyText(link);

      this.$notification.success({
        message: 'Link referral copiato',
        duration: 2
      });
    },

    download() {
      this.qrCodeGenerated.download({
        name: `qrcode-${this.selectedReseller.name.toLowerCase().replace(/\s/g, '-')}`,
        extension: 'png'
      });
    },

    showQRCodeModal(reseller) {
      this.QRCodeModalOpened = true;
      this.selectedReseller = reseller;
    },

    generateQRCode(opened) {
      if (!opened) {
        document.querySelector('#qr-code-canvas svg').remove();
        this.qrCodeGenerated = null;
        return;
      }

      this.qrCodeGenerated = new QRCodeStyling({
        width: 340,
        height: 340,
        type: 'svg',
        data: this.VUE_APP_REFERRAL_LINK_TEMPLATE + this.selectedReseller.ref,
        image: 'https://blooza-app.s3.eu-south-1.amazonaws.com/logoi4m.png',
        dotsOptions: {
          color: '#ED8224',
          type: 'rounded'
        },
        backgroundOptions: {
          // color: '#EDECEA'
        },
        cornersSquareOptions: {
          type: 'extra-rounded',
          color: '#E17516'
        },
        imageOptions: {
          imageSize: 0.5,
          margin: 6,
          crossOrigin: 'anonymous'
        }
      });

      this.qrCodeGenerated.append(document.getElementById('qr-code-canvas'));
    },

    create(e) {
      e.preventDefault();
      const form = this.newResellerForm;
      this.creating = true;
      form.validateFields(async (err, values) => {
        if (err) {
          this.creating = false;
          return;
        }

        const resp = await api.addReseller(values);
        if (resp.status === 201) {
          await this.refresh();

          form.resetFields();
          this.$notification.success({
            message: this.$t('reseller.created'),
            duration: 5
          });
          this.newModalOpened = false;
        } else {
          this.$notification.error({
            message: this.$t('reseller.createError'),
            duration: 5
          });
        }

        this.creating = false;

        // let respRequest = await api.sendSupportRequest({
        //   quotationId: this.$props.quotationId,
        //   name: values.name,
        //   email: values.email,
        //   message: values.message,
        //   supportReason: filteredReason[0]
        // });

        // if (respRequest) {
        //   form.resetFields();
        //   this.$emit('onCloseSupport');
        //   this.loading = false;
        //   this.$notification.success({
        //     message: this.$t('support.success'),
        //     duration: 5
        //   });
        // } else {
        //   form.resetFields();
        //   this.loading = false;
        //   this.$notification.error({
        //     message: this.$t('support.error'),
        //     duration: 5
        //   });
        // }

        this.$notification.destroy();
      });
    },

    async getResellers(query = {}) {
      this.gettingResellers = true;

      let resp;
      try {
        resp = await api.getResellers(query);
        this.$store.commit('setBrokerLoggedIn', true);
      } catch (error) {
        if (error.response.status === 401) {
          try {
            await api.refreshToken();
            resp = await api.getResellers(query);
            this.$store.commit('setBrokerLoggedIn', true);
          } catch (e) {
            return this.$router.replace({ name: 'broker-login' });
          }
        }
      }

      this.resellers = resp.data.data;
      this.gettingResellers = false;

      this.mapPaginationParams({ ...resp.data, data: null });
    },

    clearSearch() {
      this.getBrokerOrders();
      this.orderFilter = '';
      this.resellerFilter = null;
      this.$router.push({ name: this.$route.name });
    },

    async refresh() {
      if (this.refreshing) return false;
      const q = this.$router.currentRoute.query;
      this.refreshing = true;
      await this.getResellers(q);
      this.refreshing = false;
      return true;
    },

    async deleteReseller(id) {
      if (this.deleting[id]) return;
      Vue.set(this.deleting, id, true);
      await api.deleteReseller(id);
      await this.getResellers(this.$router.currentRoute.query);
      Vue.set(this.deleting, id, false);
    },

    mapPaginationParams(laravelPaginationData) {
      let { current_page, per_page, total, query = {} } = laravelPaginationData;

      this.paginationInfo = {
        onChange: page => {
          this.getResellers({ ...query, page: page });
          this.$router.push({ name: this.$route.name, query: { ...query, page } });
        },
        current: current_page,
        pageSize: per_page,
        total,
        showTotal: total => `${total} ordini totali`
      };
    }
  }
};
</script>
<style lang="scss"></style>
